<script lang="ts">
  interface Props {
    color?: string;
    style?: string;
    bottom?: number;
    class?: string;
  }

  let { color, style, bottom = 0, class: classes = "" }: Props = $props();
  let colorVar = $derived(color ? `var(--${color})` : null);
  let styleVar = $derived(style ? `${style}` : `dashed`);
</script>

<span
  style="{colorVar ? `--_color: ${colorVar}` : ''}; --_style: {styleVar}; --_bottom: {bottom}px;"
  class="line-y-max-value absolute left-0 right-0 {classes}"
></span>

<style lang="postcss">
  span {
    --_fallback-color: color-mix(in oklab, var(--fg), var(--bg) 87.5%);
    /* position need -2px for some reason to be correct */
    bottom: calc(var(--_bottom) - 2px);
    border: 0 var(--_style) var(--_color, var(--_fallback-color));
    border-block-end-width: 1px;
  }
</style>
